import { render, staticRenderFns } from "./UserInvitationConfirm.vue?vue&type=template&id=48136c3e&scoped=true"
import script from "./UserInvitationConfirm.vue?vue&type=script&lang=js"
export * from "./UserInvitationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48136c3e",
  null
  
)

export default component.exports